import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { IoIosArrowDown } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

import OrderSelectModal from '../../../components/Modals/OrderSelectModal/OrderSelectModal';
import LoadingOverlay from '../../../components/common/LoadingOverlay';

function OrderSelect({ eventID, selectedOrder, onSelectOrder, orders, loading }) {
    const { t } = useTranslation();
    const [showOrderSelect, setShowOrderSelect] = useState(false);
    const selected = orders.length && orders.find(o => o.orderID === selectedOrder);

    return (
        <div className="CategoryList">
            {loading ?
                 <div style={{ position: 'relative', padding: 13 }}>
                    <LoadingOverlay />
                </div>
            : null}

            {!loading ?
                <>
                    {orders.length && selected ?
                        <Button
                            className="p-0"
                            variant="link"
                            style={{ textDecoration: 'none' }}
                            onClick={() => setShowOrderSelect(true)}
                        >
                            {selected.name} ({selected.orderNumber}) <IoIosArrowDown />
                        </Button>
                    :
                        <div className="p-0">
                            {t('orders.no_orders')}
                        </div>
                    }
                </>
            : null}

            {showOrderSelect ?
                <OrderSelectModal
                    show
                    onHide={() => setShowOrderSelect(false)}
                    eventID={eventID}
                    selectedOrder={selectedOrder}
                    onSelectOrder={onSelectOrder}
                    selected={selected}
                />
            : null}
        </div>
    );
}

export default OrderSelect;
